import { ProviderFormField } from './provider-form-field';
import OrganisationPresenter from '@/presenters/organisation-presenter';
import BodyPresenter from '@/presenters/body-presenter';
import { ISelectOption, selectOptionsFrom } from '@/platform/controls/i-select-option';
import { toRaw, ref, Ref } from 'vue';
import { Organisation } from '@/presenters/organisation';
import { Body } from '@/presenters/body';

export class ProviderEditor {
	public provider = ref<ProviderFormField | undefined>();
	public organisations = ref<readonly ISelectOption<string>[]>([]);
	public bodies = ref<readonly ISelectOption<string>[]>([]);

	public constructor(providerFormField: Ref<ProviderFormField | undefined>) {
		this.provider = providerFormField;
	}

	private async populateOrganisationsWithSelected(): Promise<void> {
		const providerRaw = toRaw(this.provider.value);
		const providerOrganisationId = providerRaw?.providerOrganisationId.value;
		const organisation = providerOrganisationId ? await OrganisationPresenter.retrieve(providerOrganisationId) : null;
		const organisations = organisation ? [organisation] : [];

		this.organisations.value = selectOptionsFrom(
			organisations,
			(o) => o.id,
			(o) => this.formatProviderLabel(o)
		);
	}

	private async populateBodiesWithSelected(): Promise<void> {
		const providerRaw = toRaw(this.provider.value);
		const providerBodyId = providerRaw?.providerBodyId.value;
		const body = providerBodyId ? await BodyPresenter.retrieve(providerBodyId) : null;
		const bodies = body ? [body] : [];

		this.bodies.value = selectOptionsFrom(
			bodies,
			(b) => b.id,
			(b) => this.formatProviderLabel(b)
		);
	}

	public async organisationsRemoteSearch(query: string | undefined): Promise<void> {
		this.organisations.value = selectOptionsFrom(
			await OrganisationPresenter.search(query),
			(o) => o.id,
			(o) => this.formatProviderLabel(o)
		);
	}

	public async bodiesRemoteSearch(query: string | undefined): Promise<void> {
		this.bodies.value = selectOptionsFrom(
			await BodyPresenter.search(query),
			(o) => o.id,
			(o) => this.formatProviderLabel(o)
		);
	}

	private formatProviderLabel(organisation: Organisation | Body): string {
		return `${organisation.name} (ID: ${organisation.id})`;
	}

	public async mounted(): Promise<void> {
		await this.populateOrganisationsWithSelected();
		await this.populateBodiesWithSelected();
	}
}
